export const environment = {
  production: true,
  environment: 'production',
  appName: 'Gozem Accounts',
  accountsApiUrl: 'https://accounts.gozem.co',
  /**
   * Redirect targets this environment may hand an authorization code to.
   *
   * The service validates independently and is the authority. This list exists so a foreign
   * redirect_uri fails on OUR origin with our own error page, rather than after a round trip — the
   * rule GPGT-41350 states as "validate before rendering any UI".
   *
   * A leading dot opts a host into its subdomains ('.staging.gozem.co' matches 'app.staging…').
   * Exact hostname otherwise: a prefix test would accept 'gozem.co.attacker.tld'.
   */
  allowedRedirectOrigins: ['https://merchant.gozem.co', 'https://developers.gozem.co'] as const,
};
